export enum FeedTabType {
  TAB_DISCOVERY = "TAB_DISCOVERY",
  TAB_LIBRARY = "TAB_LIBRARY",
}
